import React from 'react';
import { StarIcon } from 'lucide-react';
import { BUNDLE_IMAGE, heroChips } from '../data/content';
import { CtaButton } from './ui/CtaButton';
import { Reveal } from './ui/Reveal';
export function Hero() {
  return <section className="grain relative flex min-h-[calc(100dvh-2.5rem)] flex-col overflow-hidden bg-cream px-4 pb-4 pt-3 sm:block sm:min-h-0 sm:px-5 sm:pb-0 sm:pt-12" data-id="element-92" data-mp="9lv16qmocfvu">
      <div className="mx-auto flex w-full max-w-6xl flex-1 flex-col text-center sm:block" data-id="element-93" data-mp="1297cu5rar3ad">
        <Reveal data-id="element-94" data-mp="xae6qyecaek8">
          <p className="display inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 text-[0.58rem] leading-tight tracking-[0.01em] text-orange shadow-card sm:gap-3 sm:px-7 sm:py-4 sm:text-[1.1rem]" data-id="element-95" data-mp="x9urxqjzk6af">
            <span className="relative flex h-2.5 w-2.5 shrink-0 sm:h-4 sm:w-4" aria-hidden="true" data-id="element-96" data-mp="nczrh245jvti">
              <span className="absolute inset-0 rounded-full bg-sun" data-id="element-97" data-mp="3d1s9sv56tfs2" />
              <span className="absolute inset-0 animate-ping rounded-full bg-sun/70" data-id="element-98" data-mp="382p6bf4uvhm7" />
            </span>
            Offerta di lancio attiva · accesso istantaneo
          </p>
        </Reveal>

        <Reveal delay={0.04} data-id="element-99" data-mp="3o7lqxnqt30nd">
          <h1 className="display mx-auto mt-3 max-w-[21ch] text-[1.85rem] text-ink sm:mt-8 sm:text-[3.7rem] lg:text-[4.5rem]" data-id="element-100" data-mp="3o7vktmez1ryc">
            Trasforma le ore davanti allo schermo in{' '}
            <span className="text-orange" data-id="element-101" data-mp="3e8wjyq0g70lw">
              robot, macchine e invenzioni costruite da tuo figlio.
            </span>
          </h1>
        </Reveal>

        <Reveal delay={0.08} data-id="element-102" data-mp="30fya5yn9d5yt">
          <p className="mx-auto mt-3 max-w-2xl text-[15.5px] font-semibold leading-snug text-ink/70 sm:mt-8 sm:text-[1.55rem] sm:leading-relaxed" data-id="element-103" data-mp="358ho4wpuy345">
            Costruite insieme robot, veicoli e macchine con materiali che hai
            già in casa.{' '}
            <span className="rounded bg-sun/40 px-1 font-black text-ink" data-id="element-104" data-mp="2vj7rr4nzdya8">
              Meno tempo passivo, più creatività, logica e problem-solving
            </span>
            , con progetti passo-passo e senza esperienza precedente.
          </p>
        </Reveal>

        <Reveal delay={0.1} className="flex min-h-0 flex-1 sm:block" data-id="element-105" data-mp="s334ncg7smx0">
          <div className="mx-auto flex min-h-0 w-full max-w-5xl flex-1 items-center sm:mt-10 sm:block" data-id="element-106" data-mp="nbl2il2gggag">
            <img src={BUNDLE_IMAGE} alt="I sei volumi del Laboratorio del Giovane Inventore con tablet, monitor e telefono che mostrano lo stesso materiale" className="mx-auto max-h-full w-[88%] object-contain drop-shadow-[0_16px_28px_rgba(16,49,38,0.18)] sm:w-full sm:max-w-3xl sm:drop-shadow-[0_28px_44px_rgba(16,49,38,0.2)]" loading="eager" width={1656} height={932} data-id="element-107" data-mp="ibozao1l0svy" />
          </div>
        </Reveal>

        <p className="mt-1 hidden text-[11px] font-black uppercase tracking-[0.12em] text-ink/45 sm:mt-3 sm:block sm:text-xs" data-id="element-108" data-mp="1126ncfbgz0az">
          Laboratorio del Giovane Inventore — 6 volumi e 5 bonus
        </p>

        <div className="mt-2 flex shrink-0 flex-col items-center sm:mt-8" data-id="element-109" data-mp="3lt75ys5mbtus">
          <Reveal delay={0.06} className="w-full" data-id="element-110" data-mp="3hrdbx2pxho3l">
            <CtaButton className="w-full whitespace-nowrap px-4 py-3 text-[13px] sm:w-auto sm:px-16 sm:py-6 sm:text-xl" tone="moss" size="xl" showIcon={false} data-id="element-111" data-mp="3hpse948bhp1i">
              Scopri il Laboratorio
            </CtaButton>
          </Reveal>

          <ul className="mt-2.5 flex flex-wrap items-center justify-center gap-1.5 sm:mt-7 sm:gap-2.5" data-id="element-112" data-mp="269zhpr6e2tnc">
            {heroChips.map(chip => <li key={chip} className="rounded-full bg-white px-2.5 py-1 text-[10px] font-black leading-tight text-moss shadow-edge sm:px-5 sm:py-2.5 sm:text-sm" data-id="element-113" data-mp="2b0zf0xjf7dqd">
                {chip}
              </li>)}
          </ul>

          <p className="mt-2.5 flex flex-col items-center gap-1 text-[11px] font-black leading-snug text-ink sm:mt-7 sm:flex-row sm:gap-3 sm:pb-16 sm:text-lg" data-id="element-114" data-mp="2kxkk1ivfwou7">
            <span className="flex gap-0.5" aria-hidden="true" data-id="element-115" data-mp="2tzbnsi6f6llf">
              {Array.from({
              length: 5
            }).map((_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-sun text-sun sm:h-5 sm:w-5" data-id="element-116" data-mp="unrdt69gy1xm" data-mpi={index} />)}
            </span>
            <span className="max-w-[38ch] sm:max-w-none" data-id="element-117" data-mp="zm2lpbg7e2d7">
              “Creato per trasformare il tempo in casa in tempo speso a
              costruire, testare e pensare.”
            </span>
          </p>
        </div>
      </div>
    </section>;
}